<div class="flex items-center gap-3 my-2">
  @if (icon) {
    <tui-icon data-testid="icon" [icon]="icon" />
  }

  <div>
    @switch (titleSize) {
      @case (Size.LARGE) {
        <h1>{{ title }}</h1>
      }
      @case (Size.MEDIUM) {
        <h4>{{ title }}</h4>
      }
      @case (Size.SMALL) {
        <h6>{{ title }}</h6>
      }
      @default {
        <p>{{ title }}</p>
      }
    }
    @if (!!subtitle) {
      <h6 class="text-slate-600">{{ subtitle }}</h6>
    }
  </div>

  @if (!!counter) {
    <span class="!font-bold mt-1" data-testid="counter" size="l" tuiBadge
      >{{ counter }}{{ maxCount ? '/' + maxCount : '' }}</span
    >
  }
</div>
